import { createStyles } from '@mui/styles';

// Types
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '30px',
        '@media(max-width: 990px)': {
            display: 'block'
        }
    },
    leftSection: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        flex: '1 0 0',
        '@media(max-width: 990px)': {
            marginBottom: 15
        }
    },
    upperText: {
        textTransform: 'uppercase',
        color: '#A4A4A4',
        fontSize: '1.5rem',
        '@media(max-width: 1300px)': {
            fontSize: '1.4rem',
        }
    },
    lowerText: {
        lineHeight: '28px',
        '@media(max-width: 1300px)': {
            fontSize: '1.6rem'
        }
    },
    rightSection: {
        display: 'flex'
    }
});
